export interface HomeRentalProperty {
  id: string;
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  /** Dedicated interactive 3D twin for this property, when available. */
  twinPath?: string;
  /** Map framing level selected for a building-centre location. */
  zoom: number;
  /** Describes how accurately the property can be located. */
  geocodePrecision: 'building-centroid';
}

/**
 * Properties intentionally configured for the Homes & Rentals experience.
 * Unit-level coordinates were not available, so this pin uses the verified
 * Alpine Woodsmoke building centroid.
 */
export const HOME_RENTAL_PROPERTIES: readonly HomeRentalProperty[] = [
  {
    id: 'alpine-woodsmoke-unit-4',
    name: 'Alpine Woodsmoke · Unit 4',
    address: 'Unit 4, 23 Bogong High Plains Road, Falls Creek VIC 3699',
    latitude: -36.8636969,
    longitude: 147.2845645,
    twinPath: '/events/alpine-woodsmoke-unit-4/twin',
    zoom: 17,
    geocodePrecision: 'building-centroid',
  },
];
